import { render, staticRenderFns } from "./UserRoleSetup.vue?vue&type=template&id=30d63a96&"
import script from "./UserRoleSetup.vue?vue&type=script&lang=ts&"
export * from "./UserRoleSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports